import { API, graphqlOperation } from 'aws-amplify';

/**
 * Minimal wrapper around AWS Amplify API
 * This is a thin abstraction to centralize GraphQL operations
 * No changes to existing logic - just a pass-through
 */
class ApiClient {
  /**
   * Execute a GraphQL query
   */
  async query(operation, variables = {}) {
    const result = await API.graphql(graphqlOperation(operation, variables));
    return result;
  }

  /**
   * Execute a GraphQL mutation
   */
  async mutate(operation, variables = {}) {
    const result = await API.graphql(graphqlOperation(operation, variables));
    return result;
  }

  /**
   * Direct access to API.graphql for complex operations
   * Maintains backward compatibility with existing code
   */
  async graphql(operation) {
    return await API.graphql(operation);
  }
}

export default new ApiClient();